import {
  checkNull,
  KeyValPair,
  ListContent,
  ReportContainer,
} from "../constant";
import { formatHomeCareSummary } from "./home-care-summary";

interface RosBlockProps {
  data: any;
}

const RosBlock = ({ data }: RosBlockProps) => {
  if (!checkNull(data?.rosTemplates)) return null;

  return (
    <ReportContainer label="Review of Systems">
      <ListContent
        list={data?.rosTemplates}
        renderItem={(item) => (
          <KeyValPair
            k={item?.templateNameType}
            v={
              formatHomeCareSummary(
                item?.templateNameType,
                item?.description
              ) ?? ""
            }
          />
        )}
      />
    </ReportContainer>
  );
};

export default RosBlock;
